/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable @typescript-eslint/no-explicit-any */
import React, { FC, useState, ChangeEvent, useEffect } from 'react'
import { FaUserAlt, FaChartLine, FaEnvelope, FaEnvelopeOpen } from 'react-icons/fa'
import API from '@aws-amplify/api'
import Skeleton from '@material-ui/lab/Skeleton'
import { InputGroup, FormControl } from 'react-bootstrap'
import './styles.scss'
import { inject, observer } from 'mobx-react'
import { withRouter, RouteComponentProps } from 'react-router-dom'
import { Search as SearchStore } from '../../../stores/search'

interface Props extends RouteComponentProps {
  // eslint-disable-next-line react/require-default-props
  search?: SearchStore
}

const ReadyRoom: FC<Props> = ({ search }): JSX.Element => {
  const [customDay, setCustomDay] = useState('1')
  const [loading, setLoading] = useState(false)
  const [reportingData, setReportingData] = useState<any>()
  const highlights = ['1 DAY', '7 DAYS', '15 DAYS', '30 DAYS', '60 DAYS', '90 DAYS']

  const getReportingData = async (timeRange): Promise<any> => {
    let response
    setLoading(true)
    try {
      response = await API.get('mav-outlook-api', `/users/reports?timeRange=${timeRange}`, {})
      setLoading(false)
      return response
    } catch (e) {
      setLoading(false)
      console.error(e)
      return e
    }
  }

  const sum = (datas): number => {
    let dataSum = 0
    datas?.forEach(element => {
      dataSum += element?.opened
    })
    return dataSum
  }

  const [rawData, setrawData] = useState<any>()

  const onCustomDayChange = async (day): Promise<void> => {
    search?.setEngagementHighlightFilter({})
    let timeRange = day.replace(' DAYS', '').replace(' DAY', '')
    setCustomDay(timeRange)
    timeRange += 'D'
    const temp = await getReportingData(timeRange)
    setrawData(temp)

    const datas = {
      prospects: temp?.prospectsAdded?.combined,
      sent: temp?.sentEmails?.combined,
      replied: temp?.replyData?.combined[1].value,
      opened: sum(temp?.openData?.combined),
    }
    setReportingData(datas)
  }

  useEffect(() => {
    onCustomDayChange('1 DAY')
  }, [])

  const handleChangeSelectedhighlight = (type): void => {
    if (search?.EngagementHighlightFilter?.filterType === type) {
      search?.setEngagementHighlightFilter({})
      return
    }
    const dataObj = {}
    if (type === 'new') {
      rawData?.prospectsAdded?.detailedInfo?.map(item => {
        dataObj[item?.email] = true
      })
    }
    if (type === 'email-sent') {
      rawData?.recentData?.combined?.map(item => {
        dataObj[item?.Recipient] = true
      })
    }
    if (type === 'email-opened') {
      rawData?.recentData?.combined
        ?.filter(item => item?.Opened)
        ?.map(item => {
          dataObj[item?.Recipient] = true
        })
    }
    if (type === 'email-replied-by-lead') {
      rawData?.recentData?.combined
        ?.filter(item => item?.Replied)
        ?.map(item => {
          dataObj[item?.Recipient] = true
        })
    }

    search?.setEngagementHighlightFilter({
      filterType: type,
      leadsEmails: dataObj,
    })
  }

  return (
    <div className="ready-room">
      <div className="highlights">
        <div className="highlights-container">
          <FaChartLine className="user-icon" />
          <p className="title">ENGAGEMENT HIGHLIGHTS</p>
          {highlights.map(item => (
            <div
              role="button"
              tabIndex={0}
              className={`highlight ${
                customDay === item.replace(' DAYS', '').replace(' DAY', '') ? 'active' : ''
              }`}
              key={`engagement highlight - ${item}`}
              onClick={(): Promise<void> => onCustomDayChange(item)}
              onKeyDown={(): void => {}}
            >
              {item}
            </div>
          ))}
          <InputGroup>
            <InputGroup.Text>CUSTOM DAYS</InputGroup.Text>
            <FormControl
              autoFocus
              type="number"
              min={1}
              placeholder="CUSTOM DAYS"
              value={customDay.toString()}
              className="custom-day"
              onChange={(e: ChangeEvent<HTMLInputElement>): void => {
                onCustomDayChange(e.currentTarget.value)
              }}
            />
          </InputGroup>
        </div>
      </div>
      {loading ? (
        <div className="ready-room-body marginLeft">
          <Skeleton variant="rect" width="200px" height="65px" />
          <Skeleton variant="rect" width="200px" height="65px" />
          <Skeleton variant="rect" width="200px" height="65px" />
          <Skeleton variant="rect" width="200px" height="65px" />
        </div>
      ) : (
        <div className="ready-room-body">
          <div
            className={`ready-room-card cursor-pointer ${
              search?.EngagementHighlightFilter?.filterType === 'new' ? 'highlight-filtered' : ''
            }`}
            onClick={(): void => handleChangeSelectedhighlight('new')}
          >
            <FaUserAlt className="user-icon" />
            <h3>{reportingData?.prospects}</h3>
            <p className="card-body">NEW CONTACTS ADDED</p>
          </div>
          <div
            className={`ready-room-card cursor-pointer ${
              search?.EngagementHighlightFilter?.filterType === 'email-sent'
                ? 'highlight-filtered'
                : ''
            }`}
            onClick={(): void => handleChangeSelectedhighlight('email-sent')}
          >
            <FaEnvelope className="user-icon" />
            <h3>{reportingData?.sent}</h3>
            <p className="card-body">Emails Sent</p>
          </div>
          <div
            className={`ready-room-card cursor-pointer ${
              search?.EngagementHighlightFilter?.filterType === 'email-replied-by-lead'
                ? 'highlight-filtered'
                : ''
            }`}
            onClick={(): void => handleChangeSelectedhighlight('email-replied-by-lead')}
          >
            <FaEnvelope className="user-icon" />
            <h3>{reportingData?.replied}</h3>
            <p className="card-body">Emails replied</p>
          </div>
          <div
            className={`ready-room-card cursor-pointer ${
              search?.EngagementHighlightFilter?.filterType === 'email-opened'
                ? 'highlight-filtered'
                : ''
            }`}
            onClick={(): void => handleChangeSelectedhighlight('email-opened')}
          >
            <FaEnvelopeOpen className="user-icon" />
            <h3>{reportingData?.opened}</h3>
            <p className="card-body">Emails opened</p>
          </div>
        </div>
      )}
    </div>
  )
}

export default inject('search')(withRouter(observer(ReadyRoom)))
